export default "__VITE_ASSET__KZ2k$ivO__"